import MobileApps from "../../../Assets/images/blogs/Mobileapp.jpeg";
import Rocket from '../../../Assets/images/blogs/rocket.jpeg';
import Content from '../../../Assets/images/blogs/content.jpeg';

export const BlogsData = [
    {
        id: 0,
        title: "Harnessing AI in Digital Marketing",
        desc: "Learn how AI is transforming digital marketing with machine learning and predictive analytics, enhancing customer engagement and campaign optimization.",
        img: Rocket,
    },
    {
        id: 1,
        title: "Progressive Web Apps: Mobile Experience Redefined",
        desc: "Explore how Progressive Web Apps (PWAs) are revolutionizing mobile browsing, offering lightning-fast performance and seamless user experiences across devices.",
        img: MobileApps,
    },
    {
        id: 2,
        title: "Content Marketing in 2024: Engage, Educate, Convert",
        desc: "Explore innovative content marketing strategies for 2024, designed to captivate audiences, foster engagement, and drive conversion in the digital landscape.",
        img: Content,
    },
]